import DisplayerComponent from "./components/DisplayerComponent";

function App() {
  return (
    <>
      <DisplayerComponent />
    </>
  );
}

export default App;
